export default "__VITE_ASSET__5dfce9db__"